import { type ReactNode, useCallback, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useTracking } from "../tracking/TrackingContext";

function normalizePath(pathname: string) {
  return pathname
    .replace(/\/t\/[^/$]+((\/[^/]+)*$)?/, function (_, end) {
      return `/t/:token${end || ""}`;
    })
    .replace(/\/signer\/[^/$]+((\/[^/]+)*$)?/, function (_, end) {
      return `/signer/:hash${end || ""}`;
    });
}

// todo: we should review this set up and see if we should anonymize anything before sending to GA / BI-team
export function TrackPageViews({ children }: { children: ReactNode }) {
  const tracking = useTracking();
  const trackLocation = useCallback(
    function trackLocation(location: Location) {
      tracking.pageView({
        path: normalizePath(location.pathname) || "/",
        title: document.title,
      });
    },
    [tracking],
  );

  const location = useLocation();

  useEffect(() => {
    const timeout = setTimeout(trackLocation, undefined, location);

    return () => clearTimeout(timeout);
  }, [location, trackLocation]);

  const timeout = useRef<number | null>(null);

  useEffect(() => {
    if (timeout.current) clearTimeout(timeout.current);
    timeout.current = setTimeout(trackLocation, undefined, location);
  }, [location, trackLocation]);

  useEffect(() => {
    tracking.appLoad();
  }, [tracking]);

  return <>{children}</>;
}
